import Angular from "angular";
import Moment from "moment/moment";

let ConvertToModule = Angular.module('convert-to', []);

ConvertToModule.directive('convertTo', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
            ngModel.$parsers.unshift(function(value) {
                if('integer' == attrs.convertTo){
                    return parseInt(value, 10);
                }

                if('float' == attrs.convertTo){
                    return parseFloat(value);
                }

                if('moment' == attrs.convertTo){
                    return new Moment(value);
                }

                throw "Unknown conversion type: " + attrs.convertTo;
            });
        }
    };
});

export default ConvertToModule;



// WEBPACK FOOTER //
// ./src/modules/core/directives/convert-to.js